<style type="text/css">
@media only screen and (max-width: 992px) {
    .v-sidebar-menu {
         z-index: 1100 !important ;
         } 
  }
  .v-sidebar-menu{
    top: 55px !important;
    width: 270px!important;
    position: fixed !important;
    padding-bottom: 0px !important;
    max-height: 91.5vh !important;
     z-index: 0 ;
    transition: all 0.4s;
  }
  .v-sidebar-menu.white-theme .collapse-btn{
    display: none !important;
  }
  .v-sidebar-menu .vsm-arrow:after {
    content: '\f078' !important;
    font: normal normal normal 15px/1 FontAwesome !important;
    color: #424242 !important;
    right: 11px !important;
    top: 50% !important;
    height: 34px !important;
    padding: 15px 0px 0px 0px !important;
    position: absolute !important;
    pointer-events: none !important;
  }
  .v-sidebar-menu .vsm-arrow {
    top:3% !important;
  }
  .v-sidebar-menu .vsm-arrow.open-arrow {
    top: 50% !important;
    right: -1px !important;
  }
  .v-sidebar-menu .collapse-btn:after {
    content: '\f07e' !important;
    font: normal normal normal 15px/1 FontAwesome !important;
    color: #424242 !important;
    right: 50% !important;
    top: 7% !important;
    height: 34px !important;
    padding: 15px 0px 0px 8px !important;
    position: absolute !important;
    pointer-events: none !important;
  }
  .v-sidebar-menu .vsm-dropdown>.vsm-list {
    padding:0px !important;
    padding-left: 5px !important;
  }
  .v-sidebar-menu.vsm-collapsed{
    display: none !important;
  }
  .v-sidebar-menu .vsm-title{
    font-size: 15px;
  }
.sidebar-fixed .main, .sidebar-fixed .app-footer{
  margin-left:270px;
}
</style>

<template>
  <sidebar-menu :menu="navItem" class="white-theme" :showOneChild = "true"></sidebar-menu>
</template>

<script>
  import CryptoJS from 'crypto-js';
  export default {
    name: 'sidebar',
    components: {},
    data () {
      return {
        navItem: [],
    }
  },
    mounted(){
      var permissionEncrypt = window.localStorage.getItem('permissiondata');
      var bytes  = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      let beforeFilter=JSON.parse(plaintext);
      this.navItem=beforeFilter.filter(function(el){
      return el.href!="/invalidurl" && el.href!="/changepassword" && el.href!="/inwardEdit";
      })

    },
    methods: {
      handleClick (e) {
        e.preventDefault();
        e.target.parentElement.classList.toggle('open');
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sidebar.vue?80ef4aae